<otui-card class="post-container" [ngClass]="'background-gradient-' + theme">
  <div class="post-header">
    @if (profile) {
    <div class="post-profile">
      <otui-dropdown
        #postMenu
        [triggerLabel]="'...'"
        (click)="$event.stopPropagation()"
      >
        <button
          *ngIf="!guardianManagementMode"
          class="dropdown-item"
          (click)="onProfileClick()"
        >
          View Profile
        </button>
        @if (canEdit()) {
        <button class="dropdown-item" (click)="startEdit()">Edit post</button>
        } @if (!guardianManagementMode && profile.id !== currentUserId) { @if
        (canFollow) {
        <button class="dropdown-item" (click)="onFollowToggle()">
          {{ isFollowing ? 'Unfollow' : 'Follow' }}
        </button>
        }
        <button class="dropdown-item" (click)="startChat.emit(profile.id)">
          Direct Message
        </button>
        <button class="dropdown-item" (click)="onBlockToggle()">
          {{ isBlocked ? 'Unblock' : 'Block' }}
        </button>
        <button class="dropdown-item" (click)="onMuteToggle()">
          {{ isMuted ? 'Unmute from feed' : 'Mute from feed' }}
        </button>
        <button class="dropdown-item" (click)="openReport()">
          Report post
        </button>
        @if (ownedCommunities.length > 0) {
        <div class="dropdown-submenu">
          <span class="dropdown-item">Invite to Community</span>
          <div class="submenu">
            @for (community of ownedCommunities; track community.id) {
            <button
              class="dropdown-item"
              (click)="onInviteToCommunity(community.id)"
            >
              {{ community.name }}
            </button>
            }
          </div>
        </div>
        } }
      </otui-dropdown>
      <lib-profile-photo
        [src]="profile.avatar"
        [alt]="profile.name"
        [profileId]="profile.id"
        [enableChat]="false"
        (profileClick)="onProfileClick()"
        (startChat)="startChat.emit($event)"
      ></lib-profile-photo>
      <span class="profile-name" (click)="onProfileClick()">{{
        profile.name
      }}</span>
      @if (communityInfo) {
      <span class="community-badge">
        @if (communityInfo.logoUrl) {
        <img [src]="communityInfo.logoUrl" alt="" class="community-logo" />
        }
        <span class="community-name">{{ communityInfo.name }}</span>
      </span>
      }
    </div>
    }
    <div class="title">{{ content.title }}</div>
    <div class="subtitle">
      {{ content.createdAt | date }} @if (wasEdited) {
      <span class="edited-badge">Edited</span>
      }
    </div>
  </div>
  <div class="content">
    @if (isEditing) {
    <div class="edit-form">
      <input
        class="edit-title"
        type="text"
        [value]="editTitle"
        (input)="onEditTitleInput($event)"
      />
      <textarea
        class="edit-content"
        [value]="editContent"
        (input)="onEditContentInput($event)"
      ></textarea>
      @if (saveState?.status === 'pending') {
      <div class="edit-save-status" role="status" aria-live="polite">
        Saving changes…
      </div>
      } @if (saveState?.status === 'error' && saveState?.error) {
      <div class="edit-save-error" role="alert" aria-live="assertive">
        {{ saveState?.error }}
      </div>
      }
      <div class="edit-actions">
        <otui-button
          variant="primary"
          [disabled]="saveState?.status === 'pending'"
          (action)="saveEdit()"
          >Save</otui-button
        >
        <otui-button variant="secondary" (action)="cancelEdit()"
          >Cancel</otui-button
        >
      </div>
    </div>
    } @else {
    <div
      class="post-content"
      #contentContainer
      [innerHTML]="content.content"
    ></div>
    } @if (attachments.length > 0) {
    <div class="post-attachment">
      <h3>Attachments</h3>
      <otui-grid [columns]="6" [rows]="attachmentRows" class="attachment">
        @for (attachment of attachments; track attachment.id) {
        <otui-tile (click)="downloadAttachment(attachment)" target="_blank">{{
          attachment.name
        }}</otui-tile>
        }
      </otui-grid>
    </div>
    } @if (links.length > 0) {
    <div class="post-link">
      <h3>Links</h3>
      <otui-grid [columns]="1" [rows]="links.length">
        @for (link of links; track link.url) {
        <otui-tile class="link">
          <a [href]="link.url" target="_blank">{{ link.title }}</a>
        </otui-tile>
        }
      </otui-grid>
    </div>
    } @if (!guardianManagementMode) {
    <div class="actions">
      <lib-vote
        [postId]="content.id"
        [userId]="currentUserId"
        [currentVote]="userVote"
        [voteCount]="voteCount"
        (voteChanged)="onVoteChanged($event)"
      ></lib-vote>
      <lib-reaction
        [postId]="content.id"
        [userId]="currentUserId"
        [currentReaction]="userReaction"
        [reactionCounts]="reactionCounts"
        (reactionSelected)="onReactionChanged($event)"
      ></lib-reaction>
      <otui-button variant="success" (action)="onShare()"> Share </otui-button>
      <otui-button
        [variant]="isSaved ? 'warning' : 'secondary'"
        (action)="onSaveToggle()"
      >
        {{ isSaved ? 'Saved' : 'Save' }}
      </otui-button>
      @if (canDelete) {
      <otui-button variant="danger" (action)="onDelete()">Delete</otui-button>
      }
      <lib-comment
        (commentAdded)="onCommentAdd($event)"
        [imageUploadCallback]="commentImageUploadCallback"
      ></lib-comment>
    </div>
    } @else if (canDelete) {
    <div class="actions">
      <otui-button variant="danger" (action)="onDelete()"
        >Delete eligible post</otui-button
      >
    </div>
    }
  </div>
  @if (!guardianManagementMode) {
  <lib-comment-list
    [availableProfiles]="availableProfiles"
    (commentAdded)="onCommentReply($event)"
    [comments]="comments"
  ></lib-comment-list>
  }
</otui-card>
